import React from 'react'
import ReportNav from '../Navbar/ReportNav'
import TestDataCard from './TestDataCard'
import ImproveCard from './ImproveCard'

const FirstPage = () => {
    return (
        <>

            <div className=" outer-container bg-white w-[595px] ">
                <ReportNav />

                <div className="outer-section pt-10 pb-6 gap-9   border-b border-layout-border">
                    <div className="inner-section flex flex-col gap-6 p-4 ">
                        <div className="category-data">
                            <div className="category-info flex flex-col gap-2">
                                <div className="website-name">
                                    <h2 className='font-semibold text-color-gray-light text-xl'>Test Report for acme.com</h2>
                                </div>
                                <div className="date-interval">
                                    <p className='font-normal text-xs text-input-remark'>From 4 Jan, 2025 - 4 Feb, 2025</p>
                                </div>
                            </div>
                        </div>

                        <div className="figure-data">
                            <div className="card-sections">
                                <div className="card-wrapper flex justify-between gap-6">
                                    <TestDataCard />
                                    <TestDataCard />
                                    <TestDataCard />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom-section flex flex-col gap-9 py-6 px-4 border-b border-layout-border ">
                    <div className="heading-section flex flex-col  gap-2">
                        <div className="heading-top">
                            <h2 className='text-color-gray-light text-base font-semibold'>Sorting based on Failure</h2>
                        </div>
                        <div className="bottom-info">
                            <p className=' font-normal text-xs text-filter-color'>The Total number of Tests run in the given period The Total number of Tests run in the given periodThe Total number of Tests run in the given period</p>
                        </div>


                    </div>
                    <div className="card-sections">
                        <div className="card-sections flex flex-col gap-2">
                            <div className="card-wrapper flex justify-between gap-4">
                                <ImproveCard />
                                <ImproveCard />
                                <ImproveCard />
                                <ImproveCard />


                            </div>
                            <div className="info-section list">
                                <ul className='list-data text-[10px]  font-normal text-filter-color'>
                                    <li className="list-items">Needs Attention: <span className='text-error'>100% - 75%</span>
                                    </li>
                                    <li className="list-items">Room for Improvement: <span className='text-warning'>75% - 50%</span>
                                    </li>
                                    <li className="list-items">Fair Performance:<span className='text-success'>50% - 25% </span>
                                    </li>
                                    <li className="list-items"> Outstanding Performance: <span className='text-success-light'>25% - 0%</span></li>
                                </ul>
                            </div>

                        </div>
                    </div>

                    


                </div>

              <div className=" my-12">
              <div className="page-number bottom-5 top-10 text-xs text-filter-color font-normal px-4 flex justify-end p-4">
                Page 1
                </div>
              </div>
             
            </div>

            



        </>
    )
}

export default FirstPage